import { z } from 'zod'
import {
  trainerEventGroupWorkContextResponseSchema,
  trainerEventGroupWorkSummarySchema,
  TRAINER_EVENT_FEEDBACK_READ_CONTRACT_VERSION,
} from './trainer-event-feedback-read'
import { trainerWriteSideEffectsSchema } from './trainer-event-read'

export const trainerGroupWorkWriteResponseSchema = z.object({
  contract_version: z.literal(TRAINER_EVENT_FEEDBACK_READ_CONTRACT_VERSION),
  response: trainerEventGroupWorkSummarySchema,
  groupWork: trainerEventGroupWorkSummarySchema,
  idempotentReplay: z.boolean(),
  sideEffects: trainerWriteSideEffectsSchema,
}).passthrough()

export const trainerGroupWorkFormSchemaWriteResponseSchema = trainerEventGroupWorkContextResponseSchema

export type TrainerGroupWorkWriteResponse = z.infer<typeof trainerGroupWorkWriteResponseSchema>
export type TrainerGroupWorkFormSchemaWriteResponse = z.infer<typeof trainerGroupWorkFormSchemaWriteResponseSchema>
